import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
    table: {
        background: theme.palette.secondary.light
    },
    companyDialogContainer: {
        margin: 'auto'
        // padding: theme.spacing(3)
    },
    dialogGridContent: {
        padding: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: '90%',
        minWidth: '600px',
        minHeight: '195px'
    },
    companyDialogLoadingContainer: {
        padding: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: '90%',
        minWidth: '600px',
        minHeight: '240px'
    },
    dialogTitle: {
        textAlign: 'center'
    },
    dialogItemInput: {
        padding: theme.spacing(1)
    },
    itemInput: {
        width: '100%'
    },
    formControl: {
        minWidth: '100%'
    },
    select: {
        justifyContent: 'center', alignItems: 'center', display: 'flex'
    },
    appPopoverDeleteButton: {
        background: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.error.dark
        }
    },
    deleteAppDialogCancelButton: {
        color: theme.palette.secondary.dark
    },
    RequestPasswordRecoveryDialogCancelButton: {
        color: theme.palette.secondary.dark
    },
    dialogInputFile: {
        border: `.5px solid ${theme.palette.primary.light}`
    },
    closeIcon: {
        position: 'absolute',
        right: 4,
        top: 4,
        color: theme.palette.grey[700],
        cursor: 'pointer'
    },
    dialogLogo: {
        marginBottom: '10px',
        height: '200px',
        textAlign: 'center',
        position: 'relative',
        width: 'fit-content',
        margin: '0 auto'
    },
    dialogLogoImg: {
        maxWidth: '100%',
        maxHeight: '200px',
        objectFit: 'cover',
        borderRadius: '4px'
    },
    titleText: {
        fontSize: 30,
        color: theme.palette.secondary.contrastText,
        fontWeight: 600,
        textAlign: 'center'
    },
    successMessage: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(5),
        fontSize: 17,
        fontWeight: 300,
        textAlign: 'center'
    },
    closeButton: {
        fontWeight: 700,
        marginBottom: theme.spacing(1),
    },
    inputField: {
        width: '100%',
        marginBottom: theme.spacing(3),
        '& .MuiInputBase-root': {
            color: 'inherit'
        }
    },
    imageLoading: {
        margin: 'auto',
        minWidth: '100px',
        minHeight: '100px'
    },
}))

export default useStyles
